import { API } from 'aws-amplify';
import { Report } from 'graphql-api';
import { authHeader } from 'utils/auth';

export async function retrieveValidatedFile(
  reportId: string,
  sheetId: string,
  embedId: string
): Promise<File | null> {
  const apiName = 'oneschemaAPI';
  const path = `/report/${reportId}/oneschema/retrieve-file`;
  try {
    const headers = await authHeader();
    return await API.post(apiName, path, {
      headers,
      responseType: 'blob',
      body: {
        sheetId,
        embedId
      }
    });
  } catch (err) {
    return null;
  }
}

export async function generateOneschemaSessionToken(report: Report): Promise<Report | null> {
  const reportId = report.id;
  const apiName = 'oneschemaAPI';
  const path = `/report/${reportId}/oneschema/generate-session-token`;
  const headers = await authHeader();
  try {
    const { oneschemaSessionToken, oneschemaSessionTokenExpiredTime } = await API.get(
      apiName,
      path,
      {
        headers
      }
    );
    if (oneschemaSessionToken !== undefined && oneschemaSessionTokenExpiredTime !== undefined) {
      return { ...report, oneschemaSessionToken, oneschemaSessionTokenExpiredTime };
    } else {
      return null;
    }
  } catch (error) {
    console.log('Error: ', error);
    return null;
  }
}

export async function getOneSchemaExcelDownloadUrl(reportId: string): Promise<string | null> {
  const apiName = 'oneschemaAPI';
  const path = `/report/${reportId}/oneschema/get-excel-download-url`;
  const headers = await authHeader();
  try {
    return await API.get(apiName, path, {
      headers
    });
  } catch (error) {
    console.log('Error: ', error);
    return null;
  }
}
